<template>
  <b-container fluid style="height:470px; overflow-y:auto;">
    <h1>Add Exam</h1>
    <b-button variant="outline-success" class="float-right" @click="submitExam">Save Question</b-button>
    <b-row class="text-left">
      <b-col cols="6" offset="4">
        <b-form>
          <b-form-group label="Exam Duration Seconds">
            <b-input-group append="Sec" class="mb-1">
              <b-input
                type="number"
                placeholder="3"
                v-model="$v.form.timeDuration.$model"
                :state="$v.form.timeDuration.$dirty ? !$v.form.timeDuration.$error : null"
              ></b-input>
              <b-form-invalid-feedback>This is a required field and must be enter Time Duration</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-form-group label="Exam Passing Marks">
            <b-input
              type="number"
              placeholder="Enter Exam Passing Marks..."
              v-model="$v.form.passingMarks.$model"
              :state="$v.form.passingMarks.$dirty ? !$v.form.passingMarks.$error : null"
            ></b-input>
            <b-form-invalid-feedback>This is a required field and must be enter Passing Marks</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Exam Title">
            <b-input
              type="text"
              placeholder="Enter Exam Title..."
              v-model="$v.form.title.$model"
              :state="$v.form.title.$dirty ? !$v.form.title.$error : null"
            ></b-input>
            <b-form-invalid-feedback>This is a required field and must be enter 5 characters</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Description">
            <b-form-textarea
              placeholder="Enter your Description..."
              rows="3"
              max-rows="6"
              v-model="$v.form.description.$model"
              :state="$v.form.description.$dirty ? !$v.form.description.$error : null"
            ></b-form-textarea>
            <b-form-invalid-feedback>This is a required field and must be enter 10 characters</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Total Attempts">
            <b-input
              type="number"
              placeholder="5"
              v-model="$v.form.totalAttempts.$model"
              :state="$v.form.totalAttempts.$dirty ? !$v.form.totalAttempts.$error : null"
            ></b-input>
            <b-form-invalid-feedback>This is a required field and must be enter Total Attempts</b-form-invalid-feedback>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-modal
      id="submit-question-modal"
      ok-only
      ok-title="Close"
      no-close-on-backdrop
      hide-footer
      size="sm"
      v-model="showModal"
      scrollable
    >
      <template v-slot:modal-header="{ close }">
        <h5>Create Exam</h5>
      </template>
      <div v-if="!submiting && !responseSuccess">
        <p>Are you sure you would like to create the Exam</p>
      </div>
      <div v-else-if="submiting && !responseSuccess">
        <p>Your exam is being submited......</p>
        <b-spinner type="grow" label="Loading..."></b-spinner>
      </div>

      <div v-else>
        <p class="my-2 text-center">
          Your exam has been created successfully.
          <br />
        </p>
      </div>
      <div class="float-right">
        <b-button
          size="sm"
          variant="danger"
          class="mr-3"
          v-if="!submiting"
          @click="resetFormModal"
        >Close</b-button>
        <!-- Button with custom close trigger value -->
        <b-button
          size="sm"
          v-if="!responseSuccess"
          :disabled="submiting"
          variant="outline-success"
          @click="postData"
        >Submit</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Helper } from "../helpers";
import { HTTP } from "../utils/HTTP";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "AddExams",
  mixins: [validationMixin],
  components: {},
  data() {
    return {
      isLoading: false,
      submiting: false,
      responseSuccess: false,
      showModal: false,
      form: {
        timeDuration: null,
        passingMarks: null,
        title: null,
        description: null,
        totalAttempts: null
      }
    };
  },
  validations: {
    form: {
      timeDuration: {
        required
      },
      passingMarks: {
        required
      },
      title: {
        required,
        minLength: minLength(5)
      },
      description: {
        required,
        minLength: minLength(10)
      },
      totalAttempts: {
        required
      }
    }
  },
  computed: {},
  mounted() {},
  methods: {
    resetFormModal() {
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
      this.showModal = false;
    },
    submitExam() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.showModal = true;
    },
    async createExamApiCall() {
      this.formData = {
        exam_duration_seconds: this.form.timeDuration,
        exam_pass_mark: this.form.passingMarks,
        exam_title: this.form.title,
        description: this.form.description,
        total_attempts: this.form.totalAttempts
      };
      this.submiting = true;
      this.isLoading = true;
      const URI = "v1/training/addexam",
        headers = {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        };
      const Result = HTTP("post", URI, this.formData, headers, null, true);
      return Result.then(response => {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      }).catch(err => {
        this.isLoading = false;
        this.submiting = false;
      });
    },
    postData() {
      this.createExamApiCall();
      (this.form.timeDuration = null),
        (this.form.passingMarks = null),
        (this.form.title = null),
        (this.form.description = null),
        (this.form.totalAttempts = null),
        this.$v.$reset();
    }
  }
};
</script>